import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { LocalForm } from 'react-redux-form';
import PropTypes from 'prop-types';
import Alert from '../../container/Alert';
import AlertTranslation from '../../container/AlertTranslation';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import Spinner from '../Snowflake/as/Spinner';
import Comfirm from '../../container/Comfirm';
const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'translation.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Commercial Code Translation'
  },
  headerSubTitle: {
    id: 'translation.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload files for translation.'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class PlaceOrderMsg extends Component {
  //const { intl } = props;
  static propTypes = {
    translation: PropTypes.func.isRequired,
    reference_id: PropTypes.string
  };
  //const fileList = project.files;
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state ={
      show:true
    }
  }

  componentWillMount() {

  }
  componentDidMount() {
    //alert(JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['quotation_id']);
  //alert(JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['reference_id']);
    this.props.placeorder(
      this.props.reference_id,
      this.props.quotation_id
    );

    this.setState({show:false})
  }




  render() {
    return (
      <div className={this.state.show ?"pageHide": "page"}>
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          //subtitle={intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />

{this.state.show ? (
<div   style={{display:"block"}}>
         <Spinner />

      </div>):null}


        <AlertTranslation
          title="Exception"
          message={print(this.props.status)}
        />


        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm>
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '14px',
                    textTransform: 'none',
                    lineHeight: '150%',
                    color: '#A797979'
                  }}
                >
                  {/* {this.props.reference_id.length > 0
                    ? 'Your Commercial Code Translation request has been submitted. This task’s reference ID is ' +
                      this.props.reference_id +
                      '. You will be notified via email once the translation is complete.'
                    : 'Our system encountered technical difficulties during your request. Please submit your request again, or reach out to our support at' +
                      (
                        <a href="mailto:shiftsupport@nextpathway.com">
                          {' '}
                          shiftsupport@nextpathway.com
                        </a>
                      ) +
                      '. We are sorry for the inconvenience.'} */}

You translated code release request has been received. A confirmation notification has been sent to you, also an order has been created and under review.
<br/>
Once your order is approved, you will receive a notification email which contains an order number and a translated  code download link.”

                </label>

                <br />
                <br />
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    onClick={() => {this.handleShow(), this.props.clickOKHandler()}}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  handleShow(){
    this.setState({show:true})
  }
}

export default injectIntl(PlaceOrderMsg);



// WEBPACK FOOTER //
// ./src/components/views/PlaceOrderMsg/index.js